import React from 'react';
import {Link} from 'react-router-dom';
import {Flex} from '@components';
import {Form, Input, Checkbox, Row, Col, Upload, Button,message} from 'antd';
import {createUuid, getLoginUser} from '@utils/NHCore';
import TitleTop from '@pages/Assembly/titleTop';
import NHFetch from "@utils/NHFetch";
import NextButton from '@pages/SelfHelp/common/nextIndex'
import NHUpload from '@components/common/NHUpload'
const {TextArea} = Input;
const basicUrl = "/zzbd";

const shztList = {
    '-1':'审核不通过',
    '0':'未审核',
    '1':'审核通过',
    '2':'已办理',
    '9':'驳回'
}
export default class View extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nextUrl:this.props.nextUrl,
            search:this.props.search,

        };
    }

    componentDidMount() {
    }

    componentWillReceiveProps (nextProps) {
    }

    render() {
        const { data } = this.props;
        let zsqk = data['SFZS'];
        const { getDataView } = this.props

        return (
            <div>
                <TitleTop title="登记信息" extra={false}/>
                <div className="p-sw">
                    <div className="form_item" style={{width: '100%'}}>
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>住宿情况&nbsp;: </span></Col>
                            <Col span={20}><span>{zsqk ? (zsqk === '1' ? '住宿' : '走读') : ''}</span></Col>
                        </Row>

                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>手机号码&nbsp;: </span></Col>
                            <Col span={20}><span>{data['SJHM'] ? data['SJHM'] : ''}</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>学年&nbsp;: </span></Col>
                            <Col span={20}><span>{data['XN'] ? data['XN'] : ''}</span></Col>
                        </Row>
                        }
                        {
                            zsqk === '0' &&
                            <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                                <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                    style={{color: 'rgba(0, 0, 0, 0.85)'}}>省市区&nbsp;: </span></Col>
                                <Col span={20}><span>{data['ZDDZMC'] ? data['ZDDZMC'] : ''}</span></Col>
                            </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>居住地详细地址&nbsp;: </span></Col>
                            <Col span={20}><span>{data['JZDXXDZ'] ? data['JZDXXDZ'] : ''}</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>走读理由&nbsp;: </span></Col>
                            <Col span={20}><span>{data['SQZDLY'] ? data['SQZDLY'] : ''}</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>走读开始时间&nbsp;: </span></Col>
                            <Col span={20}><span>{data['ZDKSSJ'] ? data['ZDKSSJ'] : ''}</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>走读结束时间&nbsp;: </span></Col>
                            <Col span={20}><span>{data['ZDJSSJ'] ? data['ZDJSSJ'] : ''}</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>家长姓名&nbsp;: </span></Col>
                            <Col span={20}><span>{data['JZXM'] ? data['JZXM'] : ''}</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>家长电话&nbsp;: </span></Col>
                            <Col span={20}><span>{data['JZDH'] ? data['JZDH'] : ''}</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>本人身份证件国徽面&nbsp;: </span></Col>
                            <Col span={20}><span>{
                                
                                <NHUpload
                                    serviceMark={'ly-sm-yxwz-svc'}
                                    moduleName={'附件上传'}
                                    multiple={false}
                                    fileCountLimit={1}
                                    isEdit={false}
                                    defaultEffective={true}
                                    value={data['SFZGH'] ? data['SFZGH'] : ''}
                                />
                                }</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>上传本人身份证件人像面&nbsp;: </span></Col>
                            <Col span={20}><span>{

                                <NHUpload
                                    serviceMark={'ly-sm-yxwz-svc'}
                                    moduleName={'附件上传'}
                                    multiple={false}
                                    fileCountLimit={1}
                                    isEdit={false}
                                    defaultEffective={true}
                                    value={data['SFZRX'] ? data['SFZRX'] : ''}
                                />
                                }</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>家长身份证国徽图片&nbsp;: </span></Col>
                            <Col span={20}><span>{

                                <NHUpload
                                    serviceMark={'ly-sm-yxwz-svc'}
                                    moduleName={'附件上传'}
                                    multiple={false}
                                    fileCountLimit={1}
                                    isEdit={false}
                                    defaultEffective={true}
                                    value={data['JZSFZGH'] ? data['JZSFZGH'] : ''}
                                />
                                }</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>家长身份证件人像面&nbsp;: </span></Col>
                            <Col span={20}><span>{

                                <NHUpload
                                    serviceMark={'ly-sm-yxwz-svc'}
                                    moduleName={'附件上传'}
                                    multiple={false}
                                    fileCountLimit={1}
                                    isEdit={false}
                                    defaultEffective={true}
                                    value={data['JZSFZRX'] ? data['JZSFZRX'] : ''}
                                />
                                }</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>户主户口页&nbsp;: </span></Col>
                            <Col span={20}><span>{

                                <NHUpload
                                    serviceMark={'ly-sm-yxwz-svc'}
                                    moduleName={'附件上传'}
                                    multiple={false}
                                    fileCountLimit={1}
                                    isEdit={false}
                                    defaultEffective={true}
                                    value={data['HKBHZ'] ? data['HKBHZ'] : ''}
                                />
                                }</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>本人户口页&nbsp;: </span></Col>
                            <Col span={20}><span>{

                                <NHUpload
                                    serviceMark={'ly-sm-yxwz-svc'}
                                    moduleName={'附件上传'}
                                    multiple={false}
                                    fileCountLimit={1}
                                    isEdit={false}
                                    defaultEffective={true}
                                    value={data['HKBXS'] ? data['HKBXS'] : ''}
                                />
                                }</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>安全协议第一页&nbsp;: </span></Col>
                            <Col span={20}><span>{

                                <NHUpload
                                    serviceMark={'ly-sm-yxwz-svc'}
                                    moduleName={'附件上传'}
                                    multiple={false}
                                    fileCountLimit={1}
                                    isEdit={false}
                                    defaultEffective={true}
                                    value={data['FJID'] ? data['FJID'] : ''}
                                />
                                }</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>安全协议第二页&nbsp;: </span></Col>
                            <Col span={20}><span>{

                                <NHUpload
                                    serviceMark={'ly-sm-yxwz-svc'}
                                    moduleName={'附件上传'}
                                    multiple={false}
                                    fileCountLimit={1}
                                    isEdit={false}
                                    defaultEffective={true}
                                    value={data['AQXYTWO'] ? data['AQXYTWO'] : ''}
                                />
                                }</span></Col>
                        </Row>
                        }
                        {
                        zsqk === '0' &&
                        <Row gutter={24}  style={{margin:"10px 0px"}} style={{margin:"10px 0px"}}>
                            <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                                style={{color: 'rgba(0, 0, 0, 0.85)'}}>租房协议（房产证）&nbsp;: </span></Col>
                            <Col span={20}><span>{

                                <NHUpload
                                    serviceMark={'ly-sm-yxwz-svc'}
                                    moduleName={'附件上传'}
                                    multiple={false}
                                    fileCountLimit={1}
                                    isEdit={false}
                                    defaultEffective={true}
                                    value={data['ZFXY'] ? data['ZFXY'] : ''}
                                />
                                }</span></Col>
                        </Row>
                        }
                    </div>
                </div>
                
                <div className="text-center mt-50">
                    {this.props.shzt !== 0 &&
                    <Button disabled={true} style={{marginRight:'20px'}}>
                            {this.props.shzt === 1 && '审核中'}
                            {this.props.shzt === 2 && '审核通过'}
                            {this.props.shzt === 3 && '审核不通过'}
                            {this.props.shzt === -1 && '已撤销'}
                    </Button>}
                    {this.props.shzt !== 1 && this.props.shzt !== 2 &&
                    <Button type="primary" onClick={()=>{this.props.getDataView()}}>
                        修改
                    </Button>}
                    <NextButton nextUrl={this.state.nextUrl}  search={this.state.search}/>
                </div>
            </div>
        );
    }
}
